import { useQuery } from "@tanstack/react-query";
import type {
  StoreActivationQuote,
  StoreSubscriptionStatusView,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useStoreTierQuery(storeId: string) {
  return useQuery({
    queryKey: queryKeys.admin.storeSubscriptionStatus(storeId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionStatusView>(
        endpoints.admin.storeSubscriptionStatus(storeId),
      ),
    enabled: Boolean(storeId),
  });
}

export function useStoreActivationQuoteQuery(
  storeId: string,
  planId: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: queryKeys.admin.storeActivationQuote(storeId, planId),
    queryFn: () =>
      apiJsonClient<StoreActivationQuote>(
        endpoints.admin.storeActivationQuote(storeId, planId),
      ),
    enabled: enabled && Boolean(storeId && planId),
  });
}
